export default __webpack_public_path__ + "static/media/traitor.cc234808.mp3";